import React, { useState } from 'react';
import { errorText, labelChoices, machinesMatching, ruleSetProblem } from '../../pages/SoftwarePolicy/policyEdit';

// A new profile: the labels that pick its machines ("label is value", all must match), starting as the whole account. It is saved with no
// software; the person adds that next.
export default function AddProfileDialog({ account, devices, onSave, onClose }) {
  const [filter, setFilter] = useState([{ label: 'account', value: account }]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const choices = labelChoices(devices);
  const valuesOf = (label) => choices[Object.keys(choices).find((k) => k.toLowerCase() === String(label).trim().toLowerCase())] || [];
  const set = (i, patch) => setFilter(filter.map((f, j) => (j === i ? { ...f, ...patch } : f)));
  const problem = ruleSetProblem({ filter, rules: [] }, []);
  const clean = filter.filter((f) => f.label.trim() || f.value.trim()).map((f) => ({ label: f.label.trim(), value: f.value.trim() }));
  const matched = machinesMatching(clean, devices);

  const save = async () => {
    setSaving(true);
    setError('');
    try {
      await onSave(clean);
    } catch (ex) {
      setError(errorText(ex));
      setSaving(false);
    }
  };

  return (
    <div className="v2-dialog-host">
      <div className="v2-dialog" role="dialog" aria-label="Add profile">
        <h2>Add profile</h2>
        <p className="v2-muted" style={{ marginTop: 0 }}>The machines that have all of these labels get the software you put in the profile. The labels cannot be changed afterwards.</p>
        {filter.map((f, i) => (
          <div className="v2-filterrow" key={i}>
            <input className="v2-input" list={`v2-labels-${i}`} aria-label={`Label ${i + 1}`} value={f.label} onChange={(e) => set(i, { label: e.target.value })} />
            <span className="v2-muted">is</span>
            <input className="v2-input" list={`v2-values-${i}`} aria-label={`Value ${i + 1}`} value={f.value} onChange={(e) => set(i, { value: e.target.value })} />
            <button type="button" className="v2-del" aria-label={`Remove label ${i + 1}`} disabled={filter.length === 1} onClick={() => setFilter(filter.filter((_, j) => j !== i))}>&times;</button>
            <datalist id={`v2-labels-${i}`}>{Object.keys(choices).map((k) => <option key={k} value={k} />)}</datalist>
            <datalist id={`v2-values-${i}`}>{valuesOf(f.label).map((v) => <option key={v} value={v} />)}</datalist>
          </div>
        ))}
        <button type="button" className="v2-textbtn" disabled={filter.length >= 10} onClick={() => setFilter([...filter, { label: '', value: '' }])}>+ Add a label</button>
        <div className="v2-hint" aria-live="polite">
          {problem ? '' : matched.length ? `Matches ${matched.length} machine${matched.length === 1 ? '' : 's'} now: ${matched.map((m) => m.hostname).join(', ')}.` : 'No machine has these labels at the moment.'}
        </div>
        {problem && <div className="v2-alert info" style={{ marginTop: 10 }}>{problem}</div>}
        {error && <div className="v2-alert err" style={{ marginTop: 10 }}>{error}</div>}
        <div className="actions">
          <button type="button" className="v2-btn" onClick={onClose} disabled={saving}>Cancel</button>
          <button type="button" className="v2-btn primary" onClick={save} disabled={saving || Boolean(problem)}>{saving ? 'Saving...' : 'Add profile'}</button>
        </div>
      </div>
    </div>
  );
}
